import Carousel from '../../../../../common/widgets/Carousel';
import _ from 'lodash';
import BrandListItem from './BrandListItem';
import { BrandDiscoverModel } from '../../../models/Discover';

interface IBrandsSlideShowProps {
  title: string;
  brands: BrandDiscoverModel[];
}

const BrandsSlideshow = (props: IBrandsSlideShowProps) => {
  const { title, brands } = props;

  return (
    <section className="page-section mb-60">
      <h2 className="section-title">
        <span>{title}</span>
      </h2>
      <div className="edn-carousel edn-carousel-dots no-dots-mobile carousel-gap-30 carousel-gap-md-20 carousel-gap-xxs-10">
        {!!brands && brands.length > 3 ? (
          <Carousel
            dots={true}
            infinite={false}
            speed={500}
            slidesToShow={4}
            slidesToScroll={4}
            arrows={false}
            loading={!brands}
            responsive={[
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 3,
                },
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2.5,
                  slidesToScroll: 2.5,
                },
              },
              {
                breakpoint: 360,
                settings: {
                  slidesToShow: 1.5,
                  slidesToScroll: 1.5,
                },
              },
            ]}
          >
            {_.map(brands, (product: BrandDiscoverModel) => {
              return <BrandListItem key={product.id} {...product} />;
            })}
          </Carousel>
        ) : (
          <div className="card-list card-list-4 card-list-sm-3 card-list-xs-2">
            {brands?.map(brand => <BrandListItem key={brand.id} {...brand} />)}
          </div>
        )}
      </div>
    </section>
  );
};

export default BrandsSlideshow;
